import SETTINGS from '@/src/settings'

const getListRoutes = [
  {
    route: 'Home',
    href: '/home',
  },
  {
    route: 'StoreBag',
    href: '/store-bag',
  },
  {
    route: 'Login',
    href: '/customer/login',
  },
  {
    route: 'LoginRedirect',
    href: '/customer/login?redirect=yes',
  },
  {
    route: 'ForgotPassword',
    href: '/customer/login/forgotpassword',
  },
  {
    route: 'Dashboard',
    iconSelect: 'Dashboard',
    href: '/customer/account/dashboard',
    text: 'web_espace_client_tableau_bord',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V',
    order: 10,
  },
  {
    route: 'PurchaseManage',
    iconSelect: 'Dashboard',
    href: '/customer/account/last-purchase',
    text: 'web_espace_last_purchase',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V',
    order: 11,
  },
  {
    route: 'Order',
    iconSelect: 'Dashboard',
    href: '/customer/account/order',
    text: 'web_espace_client_mes_commandes',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V',
    order: 40,
  },
  {
    route: 'Dispute',
    iconSelect: 'Dashboard',
    href: '/customer/account/dispute',
    text: 'web_espace_client_mes_litiges',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V' && profile?.canOpenDispute,
    order: 40,
  },
  {
    route: 'Lgo',
    iconSelect: 'Dashboard',
    href: '/customer/account/lgo',
    text: 'web_espace_client_mon_lgo',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V',
    order: 52,
  },
  {
    route: 'Pots',
    iconSelect: 'Dashboard',
    href: '/customer/account/pots',
    text: 'web_cagnotte_ma_cagnotte',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => !!profile?.groupSubscriptionActive || !!profile?.groupCos,
    order: 55,
  },
  {
    route: 'DetailOrder',
    iconSelect: 'Dashboard',
    href: '/customer/account/order/view/[numOrder]',
    text: 'web_espace_client_mes_commandes',
    menuAccount: true,
  },
  {
    route: 'DetailDispute',
    iconSelect: 'Dashboard',
    href: '/customer/account/dispute/view/[numDispute]',
    text: 'web_espace_client_mes_commandes',
    menuAccount: true,
  },
  {
    route: 'EditUser',
    iconSelect: 'Dashboard',
    href: '/customer/account/edit',
    text: 'web_espace_client_informations_compte',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V',
    order: 20,
  },
  {
    route: 'PaymentManage',
    iconSelect: 'Dashboard',
    href: '/customer/account/payment/manage',
    text: 'web_espace_client_payment',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V',
    order: 30,
  },
  {
    route: 'SubcriptionManage',
    iconSelect: 'Dashboard',
    href: '/customer/account/subcription/manage',
    text: 'web_espace_client_subscription',
    menuAccount: true,
    displayMenuAccount: ({ profile }) =>
      profile.user_type !== 'V' && profile?.eligibleSubscription !== false,
    order: 50,
  },
  {
    route: 'Messages',
    iconSelect: 'Dashboard',
    href: '/customer/account/messages',
    text: 'web_messages',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V' && profile?.canMessage !== false,
    order: 51,
  },

  {
    route: 'Basket',
    iconSelect: 'Basket',
    href: '/customer/basket',
  },
  {
    route: 'BasketConfirm',
    href: '/customer/basket/confirm?success=1',
  },
  {
    route: 'Wishlist',
    iconSelect: 'Wishlist',
    href: '/customer/account/wishlist',
    text: 'web_espace_list_favori',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V',
    order: 45,
  },
  {
    route: 'RecentProducts',
    iconSelect: 'Dashboard',
    href: '/customer/account/recent-products',
    text: 'web_derniers_produits_consultes',
    menuAccount: true,
    displayMenuAccount: ({ profile }) => profile.user_type !== 'V',
    order: 46,
  },
  {
    route: 'Devis',
    href: '/customer/account/devis',
    text: 'web_espace_client_mes_devis',
  },
  /*{
    route: 'CreateUser',
    href: '/customer/create/create',
  },*/
  {
    route: 'CreateConfirm',
    href: '/customer/create/create-confirmation',
  },
  {
    route: 'CreateVendor',
    href: '/customer/create/create-vendor',
  },
  {
    route: 'CreateConfirmVendor',
    href: '/customer/create/create-confirmation-vendor',
  },
  {
    route: 'Pages',
    href: '/pages/[slug]',
  },
  {
    route: 'Product',
    href: '/products/[slug]',
  },
  { route: 'Company', href: '/company/[slug]' },
  { route: 'Brand', href: '/brand/[slug]' },
  {
    route: 'Categories',
    href: '/categories/[slug]',
  },
  {
    route: 'Catalogsearch',
    href: '/catalogsearch/result',
    queryArgsForce: {
      sortBy: 'pertinence',
      sortOrder: 'asc',
    },
  },
  {
    route: 'Brands',
    href: '/brand',
  },
  {
    route: 'Promotions',
    href: /*version == 1
        ? `/catalogsearch/result?filters=${SETTINGS.idFiltersFacet.discountId}-Y`
        :*/ `/view_brands/view?mode=discount`,
  },
  {
    route: 'Services',
    href: `/view_brands/view?mode=services`,
  },
  {
    route: 'AllCategory',
    href: `/all_categories`,
  },
  {
    route: 'EcoResponsable',
    href: `/catalogsearch/result?featuresHash=${SETTINGS.idFiltersFacet.ecoResponsableId}-Y`,
  },
  {
    // Filtre par la FEATURE Déstockage (filter_id 13). Utilisé par le menu "Déstockage"
    // (désactivé pour l'instant — voir CategoryDisplayer/index.tsx).
    route: 'Destockage',
    href: `/catalogsearch/result?featuresHash=${SETTINGS.idFiltersFacet.destockageId}-Y`,
  },
  {
    route: 'ProductLapAndPharmedistore',
    href: `/catalogsearch/result?featuresHash=11-228-568`,
  },
  {
    route: 'OctLeader',
    href: `/otc_leader`,
  },
  {
    route: 'NewProduct',
    href: `/view_brands/view?mode=new`,
  },
  {
    route: 'BestSeller',
    href: `/view_brands/view?mode=bestseller`,
  },
  {
    route: 'Pharmedicap',
    href: `/pharmedicap`,
  },
  {
    route: 'Agenda',
    href: '/agenda',
  },
  {
    route: 'Soon',
    href: '/soon',
  },
]

export default getListRoutes
